// Use structured fields for every new balance account; do not hand-format display names.
export const balanceAccountName = ({ platform, owner, strategy }) => [platform, owner, strategy].filter(Boolean).join(' · ');
